module.exports = __webpack_public_path__ + "static/media/daringfood_expowest_1.f89e93d0.png";